import {PayloadAction} from "@reduxjs/toolkit";
import _ from "lodash";
import {ItemContainerDto} from "../../model/item-containers-models/itemContainerDto";
import {
  ITEMCONTAINERS_CLEAR,
  ITEMCONTAINERS_ITEMCONTAINER_CLEAR,
  ITEMCONTAINERS_ITEMCONTAINER_FETCH
} from "./itemContainerActions";
import {REQUEST_ERROR, REQUEST_SUCCESS} from "../../middlewares/request/requestActions";

type ItemContainerId = string;

interface ItemContainerData {
  itemContainer?: ItemContainerDto;
  viewsAdditionalInfo?: any;
  error?: boolean;
}

type ItemContainerMap = Record<ItemContainerId, ItemContainerData>;

export interface ItemContainerState {
  map: ItemContainerMap;
}

const initialState = {
  map: {}
};

const itemContainerReducer = (state: ItemContainerState = {...initialState}, action: PayloadAction<any>) => {
  switch (action.type) {
    case ITEMCONTAINERS_CLEAR: {
      return {
        ...state,
        map: {}
      };
    }
    case ITEMCONTAINERS_ITEMCONTAINER_CLEAR: {
      const itemContainerMap = _.cloneDeep(state.map);
      const itemContainerId = action.payload.itemContainerId;
      delete itemContainerMap[itemContainerId];
      return {
        ...state,
        map: itemContainerMap
      };
    }

    case REQUEST_SUCCESS: {
      switch (action.payload.label) {
        case ITEMCONTAINERS_ITEMCONTAINER_FETCH: {
          const itemContainer = action.payload.response.itemContainer;
          const viewsAdditionalInfo = action.payload.response.viewsAdditionalInfo;
          const itemContainerId = action.payload.extra.itemContainerId;
          return {
            ...state,
            map: {
              ...state.map,
              [itemContainerId]: {
                itemContainer: itemContainer,
                viewsAdditionalInfo: viewsAdditionalInfo
              }
            }
          };
        }
        default:
          return state;
      }
    }
    case REQUEST_ERROR: {
      switch (action.payload.label) {
        case ITEMCONTAINERS_ITEMCONTAINER_FETCH: {
          const itemContainerId = action.payload.extra.itemContainerId;
          return {
            ...state,
            map: {
              ...state.map,
              [itemContainerId]: {
                error: true
              }
            }
          };
        }
        default:
          return state;
      }
    }

    default:
      return state;
  }
};

export default itemContainerReducer;
